import { z } from 'zod';

export interface ILoginForm {
	email?: string;
	password?: string;
	phone?: string;
	otp?: string;
}

export const LoginSchema: z.ZodType<ILoginForm> = z.object({
	email: z.string().optional().refine(
		(val) => {
			// If provided, validate email format only if it contains @
			if (!val) return true;
			return !val.includes('@') || z.string().email().safeParse(val).success;
		},
		{ message: 'Email is not valid' }
	),
	password: z.string().optional(),
	phone: z.string().optional(),
	otp: z.string().optional(),
});
